import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  /**
   * Handle HTTP errors and surface a stable user-facing message.
   */
  public handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'Something went wrong. Please try again.';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message || errorMessage;
    } else {
      const raw = error?.error?.message ?? error?.message;
      if (Array.isArray(raw)) {
        errorMessage = raw.filter(Boolean).join(', ') || errorMessage;
      } else if (typeof raw === 'string' && raw.trim() && raw !== 'undefined') {
        errorMessage = raw.trim();
      }
    }
    console.error(errorMessage);

    return throwError(() => new Error(errorMessage));
  }
}
